import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_3c348b7ae1ecc673eccd5dc80c83b84d/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}